<template>
  <div class="container bgWhite">
    <b-row>
      <b-col sm="12" class="float-right">
        <b-card>
          <b-button
            class="btn btn-lg float-right"
            type="submit"
            variant="primary"
            v-on:click="PrintSection"
          >
            <i class="fa icon-printer"></i> Cetak
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <div id="printSection">
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <div style="text-align: center">
        <img
          src="../assets/media/logoMara1.png"
          border="0"
          width="100"
          height="125"
        />
      </div>
      <br>
      <br>
      <br>
      <div style="text-align: center">
        <h1 class="center">
          <strong>COVER LETTER</strong>
        </h1>
      </div>
      <br>
      <br>
      <div class="card-body">
        <div style="margin-inline-start: 150px;">
          <div class="clearfix"></div>
          <table style="width:90%">
            <tbody>
              <tr style="vertical-align:top;">
                <td class="title">
                  <h1><span><strong>NAMA PROGRAM</strong></span></h1>
                </td>
                <td class="title">
                  <h1><strong></strong></h1>
                </td>
                <td class="title" style="text-align:left;">
                  <h1><span style="text-transform: uppercase"><strong>{{ ProgrammeName }}<br><br></strong></span></h1>
                </td>
              </tr>
              <tr style="vertical-align:top;">
                <td class="title">
                  <h1><span><strong>LALUAN</strong></span></h1>
                </td>
                <td class="title">
                  <h1><strong></strong></h1>
                </td>
                <td class="title" style="text-align:left;">
                  <h1><span style="text-transform: uppercase"><strong>{{ Path }}<br><br></strong></span></h1>
                </td>
              </tr>
              <tr style="vertical-align:top;">
                <td class="title">
                  <h1><span><strong>INSTITUSI</strong></span></h1>
                </td>
                <td class="title">
                  <h1><strong></strong></h1>
                </td>
                <td class="title" style="text-align:left;">
                  <h1><span style="text-transform: uppercase"><strong>{{ InstituteName }}<br><br></strong></span></h1>
                </td>
              </tr>
              <tr style="vertical-align:top;">
                <td class="title">
                  <h1><span><strong>KATEGORI</strong></span></h1>
                </td>
                <td class="title">
                  <h1><strong></strong></h1>
                </td>
                <td class="title" style="text-align:left;">
                  <h1><span style="text-transform: uppercase"><strong>{{ InstituteCategoryName }}<br><br></strong></span></h1>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "cover-letter",
  components: {
  },
  props: ["appId"],
  data: function () {
    return {
      Error: false,

      AppId: 0,
      InstituteName: "",
      InstituteNameOther: "",
      Intake: 0,
      ProgrammeName: "",

      InstituteCategoryName: null,
      InstituteId: 0,
      Institutes: null,
      Path: 'DALAM NEGARA',
      sCFN: 'CoverLetter: ',
    };
  },
  async mounted() {
    let fN = 'mounted: '
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetIntakes();
      await this.GetProposedStudy();
      await this.getInstitutes(this.ProgrammeId);
      if (0 < this.Institutes.length) {
        let arr = _.filter(this.Institutes, ["InstituteId", this.InstituteId]);
        if (0 < arr.length) {
          this.InstituteCategoryName = arr[0].InstituteCategoryName;
        }
      } else {
        await this.getAllInstitutes();
        let arr = _.filter(this.Institutes, ["Id", this.InstituteId]);
        if (0 < arr.length) {
          this.InstituteCategoryName = arr[0].Category;
        }
      }
    }
  },
  computed: {
  },
  methods: {
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
    async getAllInstitutes() {
      let fN = 'getAllInstitutes: ';
      return this.$API
        .get(this.$Institute, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Institutes = _.orderBy(response.data, ["InstituteName"],["asc"]);
            //this.HTECHLogger(this.sCFN + fN + 'this.Institutes = ' + JSON.stringify(this.Institutes))
          } else {
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetProposedStudy() {
      let fN = 'GetProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            console.log(JSON.stringify(response.data));
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            if (130 != response.data.CountryId) {
              this.Path = 'LUAR NEGARA';
            }
            this.Intake = this.info.IntakeId;
            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            //this.HTECHLogger(this.sCFN + fN + 'arr = ' + JSON.stringify(arr))
            this.ProgrammeId = arr[0].ProgramId;
            //this.ProgrammeName = arr[0].Name;
            this.ProgrammeName = response.data.ProgramName;
            this.InstituteId = this.info.InstituteId;
            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else this.InstituteName = this.info.InstituteName;
            console.log(
              (this.InstituteNameOther = this.info.InstituteNameOther)
            );
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getInstitutes(programmId) {
      let fN = 'getInstitutes: ';
      return this.$API
        .get(this.$InstituteByProgrammeId + "/" + programmId, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Institutes = _.orderBy(response.data, ["InstituteName"],["asc"]);
            //this.HTECHLogger(this.sCFN + fN + 'this.Institutes = ' + JSON.stringify(this.Institutes))
          } else {
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
  },
};
</script>